// date-fns format
export const DATE_FORMAT: string = "MM/dd/yyyy";

export const TIME_FORMAT: string = "hh:mm a";
